import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK = {
  image_url:
    "https://customer-assets.emergentagent.com/job_heels-dance-journey/artifacts/h6rp6tkm_ChatGPT%20Image%2017%20giu%202026%2C%2015_01_52.png",
  badge_overline: "Insegnante",
  badge_name: "Alessandro",
  eyebrow: "L'Esperienza",
  heading_line1: "Uno spazio dove",
  heading_italic: "sentirsi liberi",
  heading_line3: "di sperimentare.",
  paragraphs: [
    "Ciao! Sono Alessandro, insegnante di Heels Dance, e quest'estate ho deciso di creare una serie di appuntamenti dedicati a chi desidera mettersi in gioco.",
    "Lavoreremo insieme su attitude, tecnica, musicalità, presenza scenica e qualità del movimento.",
    "Il percorso è aperto a principianti, intermedi e avanzati.",
    "Non si tratta solo di imparare una coreografia, ma di costruire consapevolezza, fiducia e controllo del proprio corpo.",
  ],
  stats: [
    { num: "3", label: "Formati workshop" },
    { num: "3", label: "Livelli per ognuno" },
    { num: "∞", label: "Energia & passione" },
  ],
};

const STAT_COLORS = ["#A0522D", "#4F8FA8", "#A0522D"];

export const AlessandroSection = () => {
  const [content, setContent] = useState(FALLBACK);

  useEffect(() => {
    axios
      .get(`${API}/experience`)
      .then((res) => {
        if (res.data) setContent({ ...FALLBACK, ...res.data });
      })
      .catch(() => {
        /* keep fallback */
      });
  }, []);

  return (
    <section
      id="experience"
      data-testid="experience-section"
      className="relative py-28 lg:py-40 bg-[#F1E4C9]"
    >
      <div className="absolute top-0 right-0 w-[40vmin] h-[40vmin] rounded-full bg-[#7AB8D6]/30 blur-3xl pointer-events-none" />
      <div className="absolute bottom-[10%] left-[-5%] w-[28vmin] h-[28vmin] rounded-full bg-[#A8D5E5]/25 blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
          className="lg:col-span-5"
        >
          <div className="relative aspect-[3/4] overflow-hidden rounded-sm shadow-[0_30px_60px_-20px_rgba(160,82,45,0.3)]">
            <img
              src={content.image_url}
              alt={`${content.badge_name} - ${content.badge_overline}`}
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#2A1810]/80 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <p className="overline text-[#F4C77B]">{content.badge_overline}</p>
              <p className="font-serif-display text-3xl text-[#FBF6EA] mt-1">
                {content.badge_name}
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.15 }}
          className="lg:col-span-7 lg:pt-16"
        >
          <p className="overline text-[#A0522D] mb-6">{content.eyebrow}</p>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#2A1810]">
            {content.heading_line1}
            <br />
            <span className="font-serif-italic text-[#A0522D]">
              {content.heading_italic}
            </span>
            <br />
            {content.heading_line3}
          </h2>

          <div className="mt-10 space-y-6 text-[#4A3B30] text-base sm:text-lg leading-relaxed max-w-2xl">
            {content.paragraphs.map((p, i) => (
              <p key={i} style={{ whiteSpace: "pre-line" }}>
                {p}
              </p>
            ))}
          </div>

          <div className="mt-12 grid grid-cols-3 gap-6 max-w-2xl">
            {content.stats.map((s, i) => {
              const color = STAT_COLORS[i % STAT_COLORS.length];
              return (
                <div
                  key={`${s.label}-${i}`}
                  className="border-l-2 pl-4"
                  style={{ borderColor: color }}
                >
                  <div className="font-serif-display text-4xl text-[#2A1810]">
                    {s.num}
                  </div>
                  <div className="overline mt-1" style={{ color }}>
                    {s.label}
                  </div>
                </div>
              );
            })}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
